document.addEventListener('DOMContentLoaded', function() {
  // Mobile menu
  var burger = document.getElementById('navBurger');
  var mobile = document.getElementById('navMobile');
  if (burger && mobile) {
    burger.addEventListener('click', function() { mobile.classList.toggle('open'); });
  }

  // Bestsellers carousel - touch + click
  var bsTrack = document.getElementById('bsTrack');
  if (bsTrack) {
    var bsCards = bsTrack.querySelectorAll('.pcard');
    var bsIdx = 0;
    var bsMax = 0;

    function getBsVisible() {
      return window.innerWidth < 768 ? 1 : window.innerWidth < 1024 ? 2 : 4;
    }

    function updateBsMax() {
      bsMax = Math.max(0, bsCards.length - getBsVisible());
    }

    function getBsCardWidth() {
      if (!bsCards.length) return 0;
      return bsCards[0].offsetWidth + 20;
    }

    function bsGoTo(idx) {
      bsIdx = Math.max(0, Math.min(idx, bsMax));
      bsTrack.style.transform = 'translateX(-' + (bsIdx * getBsCardWidth()) + 'px)';
    }

    updateBsMax();

    var bsNext = document.getElementById('bsNext');
    var bsPrev = document.getElementById('bsPrev');
    if (bsNext) bsNext.addEventListener('click', function() { bsGoTo(bsIdx + 1); });
    if (bsPrev) bsPrev.addEventListener('click', function() { bsGoTo(bsIdx - 1); });

    // Touch swipe
    var bsStartX = 0;
    var bsDragging = false;
    bsTrack.addEventListener('touchstart', function(e) {
      bsStartX = e.touches[0].clientX;
      bsDragging = true;
    }, { passive: true });
    bsTrack.addEventListener('touchend', function(e) {
      if (!bsDragging) return;
      var diff = bsStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) {
        bsGoTo(diff > 0 ? bsIdx + 1 : bsIdx - 1);
      }
      bsDragging = false;
    }, { passive: true });

    window.addEventListener('resize', function() {
      updateBsMax();
      bsGoTo(0);
    });
  }

  // Kits carousel - touch + click
  var kitsTrack = document.getElementById('kitsTrack');
  if (kitsTrack) {
    var kCards = kitsTrack.querySelectorAll('.kit-card');
    var kIdx = 0;
    var kMax = Math.max(0, kCards.length - 3);

    function getKCardWidth() {
      return kCards.length ? kCards[0].offsetWidth + 20 : 0;
    }

    function kGoTo(idx) {
      kIdx = Math.max(0, Math.min(idx, kMax));
      kitsTrack.style.transform = 'translateX(-' + (kIdx * getKCardWidth()) + 'px)';
    }

    var kitsNext = document.getElementById('kitsNext');
    if (kitsNext) kitsNext.addEventListener('click', function() { kGoTo(kIdx + 1); });

    var kStartX = 0;
    kitsTrack.addEventListener('touchstart', function(e) {
      kStartX = e.touches[0].clientX;
    }, { passive: true });
    kitsTrack.addEventListener('touchend', function(e) {
      var diff = kStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 40) {
        kGoTo(diff > 0 ? kIdx + 1 : kIdx - 1);
      }
    }, { passive: true });
  }

  // Add to cart
  document.querySelectorAll('.pcard-add[data-id]').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var id = this.getAttribute('data-id');
      if (!id) return;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({id: id, quantity: 1})
      }).then(function(r) { return r.json(); })
        .then(function() {
          var badge = document.querySelector('.cart-badge');
          if (badge) badge.textContent = parseInt(badge.textContent || '0') + 1;
        }).catch(function(e) { console.error(e); });
    });
  });
});